import {get} from './common.js';

// Metrics

export function getMetricsAdmin(query_params={}) {
    return get('/metrics/', 'admin', query_params=query_params);
}
